import { Dispatch, SetStateAction } from 'react'

import { StringMapObject } from '@components/FileLayoutEditor/FileLayoutEditor.utils'
import { Button, Paper, Stack, Tooltip, Typography } from '@mui/material'
import { useDialogs } from '@toolpad/core/useDialogs'
import { v4 as uuid } from 'uuid'

import StringMappingDialog from '../StringMappingDialog/StringMappingDialog'
import UnitStringMappingDialog from '../UnitStringMappingDialog/UnitStringMappingDialog'

type Props = {
	columnMaps: { [key: string]: number }
	stringMapObject: StringMapObject
	setStringMaps: Dispatch<SetStateAction<StringMapObject>>
}

export default function ValueMappingButtons({ stringMapObject, setStringMaps, columnMaps }: Props) {
	const dialogs = useDialogs()

	const handleEditStringMap = async (category: string) => {
		const payload = stringMapObject[category] || [{ id: uuid(), target: '', sources: '' }]
		const editedStringMap =
			category === 'Unit'
				? await dialogs.open(UnitStringMappingDialog, payload)
				: await dialogs.open(StringMappingDialog, payload)
		if (!editedStringMap) return
		if (editedStringMap?.length) {
			return setStringMaps((prev) => ({ ...prev, [category]: editedStringMap }))
		}
		setStringMaps((prev) => ({ ...prev, [category]: null }))
	}

	return (
		<Paper>
			<Stack p={2} gap={2}>
				<Typography variant="body2">
					<b>Set Value Mapping</b>
				</Typography>
				<Stack gap={5} direction="row" justifyContent="space-around">
					{['Category', 'Customer', 'Distributor', 'Manufacturer', 'Unit'].map((id) => (
						<Tooltip
							sx={{ maxWidth: 'none' }}
							title={columnMaps[id] ? '' : `Assign "${id}" to a column to edit`}
							key={id}
						>
							<span>
								<Button
									disabled={!columnMaps[id]}
									variant={stringMapObject[id] ? 'contained' : 'outlined'}
									color="secondary"
									onClick={() => handleEditStringMap(id)}
								>
									{id}
								</Button>
							</span>
						</Tooltip>
					))}
				</Stack>
			</Stack>
		</Paper>
	)
}
